import { Controller } from "@hotwired/stimulus";

const RELATIVE_OPERATORS = [
  "is",
  "after_or_on",
  "before",
  "is_day_month",
  "after_or_on_day_month",
  "before_or_on_day_month",
  "within_the_next",
];

const DATE_OPERATORS = [
  "before_date",
  "before_or_on_date",
  "after_date",
  "after_or_on_date",
  "is_date",
];

export default class extends Controller {
  static targets = ["relativeFields", "dateFields", "monthFields"];
  static values = { operator: String, weather: Boolean };

  operatorChanged(event) {
    this.operatorValue = event.target.value;
  }

  operatorValueChanged() {
    const op = this.operatorValue;
    const isRelative = RELATIVE_OPERATORS.includes(op);
    const isDate = DATE_OPERATORS.includes(op);
    const isMonth = op === "is_in_month";

    this.toggleForecastUnits(op);

    if (this.hasRelativeFieldsTarget) {
      this.relativeFieldsTarget.classList.toggle("hidden", !isRelative);
      this.relativeFieldsTarget
        .querySelectorAll("input, select, [data-select-target='hiddenInput']")
        .forEach((el) => {
          el.disabled = !isRelative;
        });
    }
    if (this.hasDateFieldsTarget) {
      this.dateFieldsTarget.classList.toggle("hidden", !isDate);
      this.dateFieldsTarget.querySelectorAll("input").forEach((el) => {
        el.disabled = !isDate;
      });
    }
    if (this.hasMonthFieldsTarget) {
      this.monthFieldsTarget.classList.toggle("hidden", !isMonth);
      this.monthFieldsTarget
        .querySelectorAll("input, select, [data-select-target='hiddenInput']")
        .forEach((el) => {
          el.disabled = !isMonth;
        });
    }
  }

  // Weather forecasts only reach 16 days ahead, so a "within the next" window measured in
  // months can never validate — hide that unit while the forecast operator is selected.
  toggleForecastUnits(op) {
    if (!this.weatherValue || !this.hasRelativeFieldsTarget) return;

    const monthsItem = this.relativeFieldsTarget
      .querySelector("[data-select-value='months']")
      ?.closest("[data-ui--filter-target='item']");
    if (!monthsItem) return;

    const isForecast = op === "within_the_next";
    monthsItem.classList.toggle("hidden", isForecast);
    if (!isForecast) return;

    const hiddenInput = this.relativeFieldsTarget.querySelector(
      "input[name$='[time_constraint_unit]'][data-select-target='hiddenInput']",
    );
    if (hiddenInput?.value !== "months") return;

    const selectController =
      this.application.getControllerForElementAndIdentifier(
        hiddenInput.closest("[data-controller~='select']"),
        "select",
      );
    selectController?.setSelectedValue("days");
  }
}
